import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { FinancialNotificationsAPI } from 'api/settings-financials';
import {
  FinancialNotificationConfig,
  UpdateFinancialAlertPayload,
} from 'api/settings-financials/types';

export const FinancialNotificationsConfigQueryKey = (): [string] => [
  'financial-notifications-key',
];

export const useFinancialNotificationsConfigQuery = (
  options: UseQueryOptions<
    FinancialNotificationConfig[],
    unknown,
    FinancialNotificationConfig[],
    [string]
  > = {},
): UseQueryResult<FinancialNotificationConfig[]> => {
  return useQuery(
    FinancialNotificationsConfigQueryKey(),
    () => FinancialNotificationsAPI.getFinancialNotificationConfig(),
    {
      ...options,
    },
  );
};

export const useFinancialNotificationsConfigMutation = (
  configId: number,
  options: UseMutationOptions<
    FinancialNotificationConfig[],
    unknown,
    UpdateFinancialAlertPayload | FinancialNotificationConfig
  > = {},
): UseMutationResult<
  FinancialNotificationConfig[],
  unknown,
  UpdateFinancialAlertPayload | FinancialNotificationConfig
> => {
  return useMutation(
    (payload) =>
      FinancialNotificationsAPI.updateFinancialNotificationConfig(
        configId,
        payload,
      ),
    {
      ...options,
    },
  );
};
